import { computed, isRef } from 'vue';
import { useSaleAndAssetsStore } from '../stores/sale-and-assets.store.js'
import { useAdminItemBiddingStore, useItemEngineStateStore } from '@hds/admin-client-pinia-vue-sdk';
import { toBidHistory } from '../bidHistory.js';

export function useAsset(itemId) {
    if (!isRef(itemId)) {
        throw new Error('itemId must be a ref')
    }
    const saleAndAssetsStore = useSaleAndAssetsStore();
    const itemBiddingStore = useAdminItemBiddingStore();
    const itemEngineStateStore = useItemEngineStateStore();

    // VIBE-SERVER DATA
    const asset = computed(() => {
        return saleAndAssetsStore.assets[itemId.value];
    })

    const description = computed(() => {
        if (asset.value) {
            const year = asset.value?.year;
            const make = asset.value?.make;
            const model = asset.value?.model;
            return `${year} ${make} ${model}`;
        } else {
            return '';
        }
    })

    const lights = computed(() => {
        return asset.value?.lights;
    })

    const imageUrl = computed(() => {
        return asset.value?.imageUrls[0];
    })

    const runNumber = computed(() => {
        return asset.value?.runNumber;
    })

    // No feed carries a Black Book value yet, so the console shows its placeholder.
    const blackBookValue = computed(() => {
        return 16500;
    })

    // ITEM BIDDING DATA
    const biddingInfo = computed(() => {
        return itemBiddingStore.items[itemId.value];
    })

    const currentBid = computed(() => {
        return biddingInfo.value?.bid;
    })

    const nextBid = computed(() => {
        if (bidStatus.value === 'ASKING') {
            return biddingInfo.value?.bid;
        } else {
            return biddingInfo.value?.bid + biddingInfo.value?.increment;
        }
    })

    const badge = computed(() => {
        return biddingInfo.value?.badge;
    })

    const bidStatus = computed(() => {
        return biddingInfo.value?.status;
    })

    const increment = computed(() => {
        return biddingInfo.value?.increment;
    })

    const prebids = computed(() => {
        return biddingInfo.value?.proxyBids;
    })

    const proxyBidCount = computed(() => {
        return biddingInfo.value?.proxyBids?.length ?? 0;
    })

    const processedEntries = computed(() => {
        return biddingInfo.value?.processedEntries;
    })

    const bidHistory = computed(() => {
        return toBidHistory(processedEntries.value ?? []);
    })

    // ITEM ENGINE STATE DATA
    const engineStateInfo = computed(() => {
        return itemEngineStateStore.itemEngineStates[itemId.value];
    })

    const reservePrice = computed(() => {
        return engineStateInfo.value?.biddingRules?.finalization?.reservePrice;
    })

    return {
        asset,
        description,
        lights,
        imageUrl,
        runNumber,
        blackBookValue,
        biddingInfo,
        currentBid,
        nextBid,
        badge,
        bidStatus,
        increment,
        reservePrice,
        prebids,
        proxyBidCount,
        processedEntries,
        bidHistory
    }
}
